import Vue from 'vue';
import Vuex from 'vuex';

import storeFunctions from '../../../../world/spa/libs/vuexFunctions';

/* Modules */
import config from './modules/config';
import tags from './modules/tags';
import licenses from './modules/licenses';
import works from './modules/works';
import users from './modules/users';
import contacts from './modules/contacts';
import projects from './modules/projects';
import projectCategories from './modules/projectCategories';
import employments from './modules/employments';
import tasks from './modules/tasks';
import events from './modules/events';
import invites from './modules/invites';
import outgoes from './modules/outgoes';
import pricings from './modules/pricings';
import places from './modules/places';
import workPlaceAssocs from './modules/workPlaceAssocs';
import contactPlaceAssocs from './modules/contactPlaceAssocs';
import workCosts from './modules/workCosts';
import outgoCategories from './modules/outgoCategories';
import cards from './modules/cards';
import cardTypes from './modules/cardTypes';
import bankAccounts from './modules/bankAccounts';
import outgoCategoryProjectAssocs from './modules/outgoCategoryProjectAssocs';
import userCardAssocs from './modules/userCardAssocs';
import userBankAccountAssocs from './modules/userBankAccountAssocs';
import employmentCardAssocs from './modules/employmentCardAssocs';
import employmentBankAccountAssocs from './modules/employmentBankAccountAssocs';
import messageChannels from './modules/messageChannels';
import messages from './modules/messages';
import employeeExpenseReports from './modules/employeeExpenseReports';
import feedBoardAssocs from './modules/feedBoardAssocs';

Vue.use(Vuex);

export default new Vuex.Store({
  // Default
  state: {
    ...storeFunctions.rootState
  },
  getters: {
    ...storeFunctions.rootGetters
  },
  mutations: {
    ...storeFunctions.rootMutations
  },
  actions: {
    ...storeFunctions.rootActions
  },
  // Modules
  modules: {
    config,
    licenses,
    works,
    users,
    contacts,
    contactPlaceAssocs,
    projects,
    projectCategories,
    employments,
    tags,
    tasks,
    events,
    invites,
    outgoes,
    pricings,
    places,
    workPlaceAssocs,
    workCosts,
    outgoCategories,
    outgoCategoryProjectAssocs,
    cards, 
    cardTypes,
    bankAccounts,
    userCardAssocs,
    userBankAccountAssocs,
    employmentCardAssocs,
    employmentBankAccountAssocs,
    messageChannels, 
    messages,
    employeeExpenseReports,
    feedBoardAssocs
  },
  // state: {
  //   ...functions.rootState
  // },
  // getters: {
  //   ...functions.rootGetters
  // },
  // mutations: {
  //   ...functions.rootMutations
  // },
  // actions: {
  //   ...functions.rootActions
  // }
});
